import { amountToDisplayValue } from '@billy/design-system'
import { Callout } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface BalanceSheetControlCalloutProps {
  imbalance: number
}

export const BalanceSheetControlCallout = ({ imbalance }: BalanceSheetControlCalloutProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Callout
      color="danger"
      message={t('expert_balance_sheet.control.unbalanced', {
        amount: amountToDisplayValue(Math.abs(imbalance)),
      })}
      role="status"
    />
  )
}
